import { makeAutoObservable } from 'mobx'
import { AllowedSsoEmailDTO } from 'services/api/api.types'
import { RootStore } from '../../root-store/root-store'

export class AllowedSsoEmailsStore {
  list: AllowedSsoEmailDTO[] = []
  loading = false

  constructor(private rootStore: RootStore) {
    makeAutoObservable(this)
  }

  private get api() {
    return this.rootStore.generalStore.api.ssoAllowedEmailsApi
  }

  loadAllowedEmails = async (): Promise<void> => {
    this.loading = true
    try {
      const data = await this.api.list()
      this.list = data ?? []
    } finally {
      this.loading = false
    }
  }

  addEmail = async (email: string): Promise<void> => {
    const result = await this.api.add(email)
    if (!result) return
    this.rootStore.generalStore.showSuccess('Email added to allowed SSO list')
    await this.loadAllowedEmails()
  }

  updateEmail = async (id: number, email: string): Promise<void> => {
    const result = await this.api.update(id, email)
    if (!result) return
    this.rootStore.generalStore.showSuccess('Email updated')
    await this.loadAllowedEmails()
  }

  removeEmail = async (email: string): Promise<void> => {
    const result = await this.api.remove(email)
    if (!result) return
    this.rootStore.generalStore.showSuccess('Email removed from allowed SSO list')
    await this.loadAllowedEmails()
  }
}
